import { render, staticRenderFns } from "./projectShowcase.vue?vue&type=template&id=6c0dc0fc&scoped=true&"
import script from "./projectShowcase.vue?vue&type=script&lang=js&"
export * from "./projectShowcase.vue?vue&type=script&lang=js&"
import style0 from "./projectShowcase.vue?vue&type=style&index=0&id=6c0dc0fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0dc0fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
